import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { FeatureFlagsFacade } from '../../store/feature-flags/feature-flags.facade';
import { Permissions } from '../../core/enums';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

export const diagnosticsAccessGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const featureFlagsFacade = inject(FeatureFlagsFacade);
  const router = inject(Router);

  return combineLatest([
    authService.hasPermission([Permissions.AccessDiagnosticPage]),
    featureFlagsFacade.enableDiagnosticPageAccess$,
  ]).pipe(
    map(([hasPermission, featureFlagEnabled]) => {
      if (hasPermission && featureFlagEnabled) {
        return true;
      }
      router.navigate(['/unauthorized']);
      return false;
    })
  );
};
